import { m } from 'motion/react'
import { fadeSlideUp } from '../../lib/motion.ts'
import { Button } from '../button.tsx'

// RAL-162 board 1b: the fallback that works with zero context — a typo, a genuinely unknown
// route, or an unresolved reason code NotFoundPage refused to guess at. The bar graphic is the
// mark's rhythm with the third bar in oxide: a 404 drawn from the wordmark, not an illustration.
// `queueHint` is left undefined by default rather than showing an invented count — this layout
// has no subject data to draw a real one from.
export function StatementLayout({ queueHint }: { queueHint?: string } = {}) {
  return (
    <m.div variants={fadeSlideUp} initial="hidden" animate="visible" className="mx-auto max-w-xl">
      <div className="border border-border-hairline bg-ground-canvas px-8 py-9">
        <div className="mb-7 flex max-w-[220px] gap-1.5">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className={`h-[34px] flex-1 ${i === 2 ? 'bg-signal-oxide' : 'bg-track'}`} />
          ))}
        </div>

        <h1 className="max-w-[14ch] font-display text-[44px] font-extrabold uppercase leading-[0.98] tracking-tight text-ink-primary">
          There's nothing at this address
        </h1>

        <p className="mt-5 max-w-md text-base leading-relaxed text-ink-soft">
          Not a broken campaign, not a lost clip — this page simply doesn't exist. Rally is running normally.
        </p>

        <div className="mt-6 flex flex-wrap items-center gap-3 border-t border-border-hairline pt-5">
          <Button as="a" href="/">
            Go to the queue
          </Button>
          {queueHint ? <span className="font-mono text-[11px] text-ink-secondary">{queueHint}</span> : null}
        </div>
      </div>
    </m.div>
  )
}
